import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// STUB: token-based SSO handoff. A product (e.g. EQUIPR Core) would send the
// user to /sso?token=<signed>&next=<path>. We exchange the token for a session,
// then continue to `next`. Real deployment: Core mints the token server-side
// with the shared secret; here /api/auth/sso/mint is a dev helper to demo it.
export default function SsoHandoff() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next") || "/";
    if (!token) { setError("Missing SSO token."); return; }
    api.post(`/auth/sso?token=${encodeURIComponent(token)}`)
      .then((res) => { setSession(res.data.user); navigate(next, { replace: true }); })
      .catch((e) => setError(e.response?.data?.detail || "SSO sign-in failed."));
  }, [params, navigate, setSession]);

  if (error) {
    return (
      <div className="auth on-dark">
        <div className="auth__card" data-testid="sso-error">
          <div className="auth__brand">
            <span className="nav__logo">EQUIPR</span>
            <span style={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-body-lg)" }}>Academy</span>
          </div>
          <h1 style={{ fontSize: "var(--fs-card-title)", fontWeight: "var(--fw-extrabold)", margin: "0 0 10px" }}>Couldn't sign you in</h1>
          <p className="auth__hint">{error}</p>
          <button className="btn btn--dark" style={{ marginTop: "16px" }} onClick={() => navigate("/login")} data-testid="sso-manual-login">Sign in manually</button>
        </div>
      </div>
    );
  }

  return <div className="loading" data-testid="sso-resolving">Signing you in…</div>;
}
